import React, { useEffect, useState } from "react"
import * as Survey from "survey-react"
import "survey-core/modern.min.css"
import defaultSurveyConfig from "../cancerTemplateForm/template"
import { getStage, getLesions } from "../../../..//core/services/api/patientDiagnosisService"
import { uploadSpecificFile } from "../../../../core/services/api"
import fileUtils from "fileUtils"

export interface ISurveyProps {
  css: any
  json: any
  data: any
  cancerType?: any
  patientInfo?: any
  onComplete?: (survey: any) => void
  updateCallback?: any
  updateFlag?: any,
  toggleDisplayToast?: any
  // updateSelectedConsultant?: any
  hideDot?: any
}

const SurveyComponent: React.FunctionComponent<ISurveyProps> = (props) => {
  const { css, data, json, onComplete, cancerType, patientInfo, updateCallback, updateFlag, toggleDisplayToast, hideDot } = props

  const [loading, setLoading] = useState<boolean>(true)

  const [dataObj, setDataObj] = useState<any>({})

  const [pageChanged, setPageChanged] = useState<any>(false)

  useEffect(() => {
    if (data) {
      setDataObj(data)
    }
  }, [data])

  useEffect(() => {
    Survey.StylesManager.applyTheme("modern")

    Survey.FunctionFactory.Instance.register(
      "renderData",
      defaultSurveyConfig.renderData
    )

    setLoading(false)
  }, [])

  useEffect(() => {
    if (hideDot) {
      setTimeout(() => {
        let elements: any = document.querySelectorAll('span.sv-string-viewer')
        if (elements && elements?.length > 0) {
          elements?.forEach((element: any) => {
            if (element.textContent === '.') {
              // element.style.visibility = 'hidden'
              const parent: any = element.parentElement
              if (parent) {
                // parent.style.display = "none"
                parent.style.visibility = 'hidden'
              }
            }
          });
        }
      }, 0)
    }
  }, [json, pageChanged])

  if (loading) return <div>Loading ...</div>

  function fetchLesion(options: any, name: any, survey: any) {
    if (options?.responseCriteria === "With Target Lesions"
    ) {
      if (Object.keys(options?.withTargetLesions[0]).length >= 3 && (
        (options?.withTargetLesions[0]?.targetLesionsResponse) &&
        (options?.withTargetLesions[0]?.nonTargetLesionsResponse) &&
        (options?.withTargetLesions[0]?.newLesions)
      )) {
        return new Promise(function (resolve, reject) {
          getLesions({ ...options?.withTargetLesions[0], type: options?.responseCriteria })
            .then(async (res: any) => {
              resolve(res)
            })
            .catch((err: any) => console.log(err))
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve("")
        })
      }
    } else if (options?.responseCriteria === "Without Target Lesions"
    ) {
      if (Object.keys(options?.withoutTargetLesions[0]).length >= 2 && (
        (options?.withoutTargetLesions[0]?.nonTargetLesionsResponse) &&
        (options?.withoutTargetLesions[0]?.newLesions)
      )) {
        return new Promise(function (resolve, reject) {
          getLesions({ ...options?.withoutTargetLesions[0], type: options?.responseCriteria })
            .then(async (res: any) => {
              resolve(res)
            })
            .catch((err: any) => console.log(err))
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve("")
        })
      }
    } else {
      return new Promise(function (resolve, reject) {
        resolve("NA")
      })
    }
  }

  function fetchStage(options: any, name: any, survey: any) {
    let data = survey?.data
    const prefix = name.split("_")[0]
    const suffix = name.split("_")[1]
    const type = prefix === "clinicalStaging" ? "CLINICAL" : "PATHOLOGICAL"

    let t: any, n: any, m: any, figo: any, g: any, location: any, arbor: any, modifier: any, serumMarkers: any, mitoticrate: any, site: any = ""
    let tc: any, nc: any, mc: any, tp: any, np: any, mp: any = ""

    if (data) {
      if (suffix === "HeadAndNeckCancer") {
        if (options["tumorLocationDesc_HeadAndNeckCancer"]) {
          site = options["tumorLocationDesc_HeadAndNeckCancer"]
          if (site === "Pharynx") {
            if (options["pharynx_HeadAndNeckCancer"]) {
              site = options["pharynx_HeadAndNeckCancer"]
            }
          }
        }
      }
      else {
        if (data[`primarySite_${suffix}`]) {
          if (data[`primarySite_${suffix}`][0]) {
            if (data[`primarySite_${suffix}`][0][`psSite_${suffix}`]) {
              site = data[`primarySite_${suffix}`][0][`psSite_${suffix}`]
            } else if (data[`primarySite_${suffix}`][0][`psSite`]) {
              site = data[`primarySite_${suffix}`][0][`psSite`]
            }
          }
        }
      }
    }

    if (prefix === "clinicalStaging") {
      if (suffix === "Hodgkins") {
        t = options[`csPrimaryTumor_${suffix}`]
        n = options[`csRegionalLymphNodes_${suffix}`]
        m = options[`csDistantMetastasis_${suffix}`]
        figo = options[`csFigoStaging_${suffix}`]
        g = options[`csHistologicGrade_${suffix}`]
        location = options[`csLocation_${suffix}`]
        arbor = options[`csAnnArborStaging_Hodgkins_Lymphoma`]
        modifier = options[`csModifiers_Hodgkins_Lymphoma`]
        serumMarkers = options[`csSerumMarkers_${suffix}`]
        mitoticrate = options[`csMitoticRate_${suffix}`]
      } else if (suffix === "Pleural") {
        t = options[`csPrimaryTumor_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        n = options[`csRegionalLymphNodes_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        m = options[`csDistantMetastasis_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        figo = options[`csFigoStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        g = options[`csHistologicGrade_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        location = options[`csLocation_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        arbor = options[`csAnnArborStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        modifier = options[`csModifiers_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        serumMarkers = options[`csSerumMarkers_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        mitoticrate = options[`csMitoticRate_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
      } else {
        t = options[`csPrimaryTumor_${suffix}`]
        n = options[`csRegionalLymphNodes_${suffix}`]
        m = options[`csDistantMetastasis_${suffix}`]
        figo = options[`csFigoStaging_${suffix}`]
        g = options[`csHistologicGrade_${suffix}`]
        location = options[`csLocation_${suffix}`]
        arbor = options[`csAnnArborStaging_${suffix}`]
        modifier = options[`csModifiers_${suffix}`]
        serumMarkers = options[`csSerumMarkers_${suffix}`]
        mitoticrate = options[`csMitoticRate_${suffix}`]
      }
    } else if (prefix === "pathologicalStaging") {
      if (suffix === "Hodgkins") {
        t = options[`psPrimaryTumor_${suffix}`]
        n = options[`psRegionalLymphNodes_${suffix}`]
        m = options[`psDistantMetastasis_${suffix}`]
        figo = options[`psFigoStaging_${suffix}`]
        g = options[`psHistologicGrade_${suffix}`]
        location = options[`psLocation_${suffix}`]
        arbor = options[`psAnnArborStaging_Hodgkins_Lymphoma`]
        modifier = options[`psModifiers_Hodgkins_Lymphoma`]
        serumMarkers = options[`psSerumMarkers_${suffix}`]
        mitoticrate = options[`psMitoticRate_${suffix}`]
      } else if (suffix === "Pleural") {
        t = options[`psPrimary Tum_Pleural_Mesothelioma_or_Peritoneal_Mesotheliomaor`]
        n = options[`psRegionalLymphNodes_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        m = options[`psDistantMetastasis_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        figo = options[`psFigoStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        g = options[`psHistologicGrade_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        location = options[`psLocation_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        arbor = options[`psAnnArborStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        modifier = options[`psModifiers_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        serumMarkers = options[`psSerumMarkers_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
        mitoticrate = options[`csMitoticRate_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`]
      } else {
        t = options[`psPrimaryTumor_${suffix}`]
        n = options[`psRegionalLymphNodes_${suffix}`]
        m = options[`psDistantMetastasis_${suffix}`]
        figo = options[`psFigoStaging_${suffix}`]
        g = options[`psHistologicGrade_${suffix}`]
        location = options[`psLocation_${suffix}`]
        arbor = options[`psAnnArborStaging_${suffix}`]
        modifier = options[`psModifiers_${suffix}`]
        serumMarkers = options[`psSerumMarkers_${suffix}`]
        mitoticrate = options[`psMitoticRate_${suffix}`]
      }
    } else if (prefix === "tumorDetails") {
      tc = options[`csPrimaryTumor_${suffix}`]
      nc = options[`csRegionalLymphNodes_${suffix}`]
      mc = options[`csDistantMetastasis_${suffix}`]
      tp = options[`psPrimaryTumor_${suffix}`]
      np = options[`psRegionalLymphNodes_${suffix}`]
      mp = options[`psDistantMetastasis_${suffix}`]
    }

    let cancerName = ""
    let suffixLower = suffix.toLowerCase()
    for (let i = 0; i < suffix.length; i++) {
      if (suffix[i] === suffixLower[i]) {
        cancerName += suffix[i]
      } else {
        cancerName += ` ${suffix[i]}`
      }
    }

    if (suffix === "ColonCancer" || suffix === "AnalCancer" || suffix === "RectumCancer" || suffix === "GallBladderCancer" || suffix === "PancreaticCancer" || suffix === "SmallBowelAdenocarcinoma" || suffix === "BladderCancer" || suffix === "HCC" ||
      suffix === "BreastCancer" || suffix === "RCC") {
      if (Object.keys(options).length >= 3 && (t && n && m)) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim() === "Rectum Cancer" ? "Rectum Cancer" : cancerName.trim() === "H C C" ? "HCC" : cancerName.trim() === "R C C" ? "Renal Cell Carcinoma" : cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return { stage: "", suffix: suffix }
      }
    }
    else if (suffix === "GastricCancer" || suffix === "PenileCancer") {
      if (Object.keys(options).length >= 3 && (t && n && m)) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&stagingType=${type}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "CervicalCancer" || suffix === "GTN") {
      if (Object.keys(options).length >= 1 && figo) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${suffix === "GTN" ? "Gestational Trophoblastic Neoplasm" : cancerName.trim()}&otherStaging=${figo}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "Cholangiocarcinoma") {
      if (
        (Object.keys(options).length >= 3) &&
        (data[`biopsy_${suffix}`] !== "" || data[`biopsy_${suffix}`] !== undefined) &&
        (t && n && m)
      ) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&biopsy=${data[`biopsy_${suffix}`]}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "EsophagusAndEsophagogastricJunction") {
      if (Object.keys(options).length > 0) {
        if (prefix === "clinicalStaging") {
          if ((t && n && m) && data[`histopathology_${suffix}`] && data[`histopathology_${suffix}`] !== "NA") {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Esophagus Esophagogastric Junction&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else {
            return new Promise(function (resolve, reject) {
              resolve({ stage: "", suffix: suffix })
            })
          }
        } else if (prefix === "pathologicalStaging") {
          if ((t && n && m && g && location) && data[`histopathology_${suffix}`] && data[`histopathology_${suffix}`] !== "NA" && data[`histopathology_${suffix}`] === "Squamous Cell Carcinoma") {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Esophagus Esophagogastric Junction&tValue=${t}&nValue=${n}&mValue=${m}&gValue=${g}&location=${location}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else if ((t && n && m && g) && data[`histopathology_${suffix}`] && data[`histopathology_${suffix}`] !== "NA" && data[`histopathology_${suffix}`] === "Adenocarcinoma") {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Esophagus Esophagogastric Junction&tValue=${t}&nValue=${n}&mValue=${m}&gValue=${g}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else if ((t && n && m && location) && data[`histopathology_${suffix}`] && data[`histopathology_${suffix}`] !== "NA" && data[`histopathology_${suffix}`] === "Squamous Cell Carcinoma") {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Esophagus Esophagogastric Junction&tValue=${t}&nValue=${n}&mValue=${m}&location=${location}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else if ((t && n && m) && data[`histopathology_${suffix}`] && data[`histopathology_${suffix}`] !== "NA" && data[`histopathology_${suffix}`] === "Adenocarcinoma") {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Esophagus Esophagogastric Junction&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else {
            return new Promise(function (resolve, reject) {
              resolve({ stage: "", suffix: suffix })
            })
          }
        }
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "Melanoma") {
      if (Object.keys(options).length >= 3 && (
        (t && n && m && (data[`histopathology_${suffix}`] === "Uveal"))
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]} `)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      }
      else if (Object.keys(options).length >= 3 && (
        t && n && m && (data[`histopathology_${suffix}`] === "Cutaneous" || data[`histopathology_${suffix}`] === "Anal")
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}&stagingType=${type}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return { stage: "", suffix: suffix }
      }
    }
    else if (suffix === "UterineCarcinoma" || suffix === "VulvarCancer" || suffix === "OvaryCancer") {
      const stageObj = { stage: "", figoStage: "" }
      if (prefix === "clinicalStaging") {
        if (options?.csStage) {
          stageObj["stage"] = options?.csStage
        }
        if (options?.csFigoStage) {
          stageObj["figoStage"] = options?.csFigoStage
        }
      }
      if (prefix === "pathologicalStaging") {
        if (options?.psStage) {
          stageObj["stage"] = options?.psStage
        }
        if (options?.psFigoStage) {
          stageObj["figoStage"] = options?.psFigoStage
        }
      }
      if (Object.keys(options).length > 0) {
        if (figo && !(t && n && m)) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&otherStaging=${figo}`)
              .then(async (res: any) => {
                const temp = { stage: "", figoStage: res }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                const temp = { stage: "", figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
          })
        } else if ((t && n && m) && !figo) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n === "N0(i+)" ? "N0(i%2B)" : n}&mValue=${m}`)
              .then(async (res: any) => {
                const temp = { stage: res, figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                const temp = { stage: "", figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
          })
        } else if ((t && n && m) && figo) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n === "N0(i+)" ? "N0(i%2B)" : n}&mValue=${m}`)
              .then(async (res: any) => {
                stageObj["stage"] = res
                getStage(`/staging-data?cancerType=${cancerName.trim()}&otherStaging=${figo}`)
                  .then(async (res1: any) => {
                    stageObj["figoStage"] = res1
                    resolve({ stage: stageObj, suffix: suffix })
                  })
                  .catch((err: any) => {
                    stageObj["figoStage"] = ""
                    resolve({ stage: stageObj, suffix: suffix })
                  })
              })
              .catch((err: any) => {
                console.log(err)
                stageObj["stage"] = ""
                resolve({ stage: stageObj, suffix: suffix })
              })
          })
        } else {
          return new Promise(function (resolve, reject) {
            resolve({ stage: { stage: "", figoStage: "" }, suffix: suffix })
          })
        }
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: { stage: "", figoStage: "" }, suffix: suffix })
        })
      }
    }
    else if (suffix === "Hodgkins") {
      if (Object.keys(options).length >= 2 && (arbor && modifier)) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=Hodgkins Lymphoma&otherStaging=${arbor}&modifiers=${modifier}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "Pleural") {
      if (Object.keys(options).length >= 3 && (t && n && m)
      ) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=Pleural Mesothelioma Or Peritoneal Mesothelioma&tValue=${t}&nValue=${n}&mValue=${m}&location=Pleural`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "ThyroidCancer") {
      if (Object.keys(options).length >= 3 && (
        t && n && m &&
        (data[`histopathology_${suffix}`] === "Medullary" ||
          data[`histopathology_${suffix}`] === "Anaplastic")
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      }
      else if (Object.keys(options).length >= 3 && (
        t && n && m &&
        (data[`histopathology_${suffix}`] !== "Medullary" || data[`histopathology_${suffix}`] !== "Anaplastic")
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=Not Medullary&age=${patientInfo?.age >= 55 ? ">= 55 years" : "< 55 years"}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "UterineSarcoma") {
      const stageObj = { stage: "", figoStage: "" }
      if (prefix === "clinicalStaging") {
        if (options?.csStage) {
          stageObj["stage"] = options?.csStage
        }
        if (options?.csFigoStage) {
          stageObj["figoStage"] = options?.csFigoStage
        }
      }
      if (prefix === "pathologicalStaging") {
        if (options?.psStage) {
          stageObj["stage"] = options?.psStage
        }
        if (options?.psFigoStage) {
          stageObj["figoStage"] = options?.psFigoStage
        }
      }
      if (Object.keys(options).length > 0) {
        if (figo && !(t && n && m) && data[`histopathology_${suffix}`]) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&otherStaging=${figo}&histopathology=${data[`histopathology_${suffix}`]}`)
              .then(async (res: any) => {
                const temp = { stage: "", figoStage: res }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                const temp = { stage: "", figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
          })
        } else if ((t && n && m) && !figo && data[`histopathology_${suffix}`]) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n === "N0(i+)" ? "N0(i%2B)" : n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}`)
              .then(async (res: any) => {
                const temp = { stage: res, figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                const temp = { stage: "", figoStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
          })
        } else if ((t && n && m) && figo && data[`histopathology_${suffix}`]) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n === "N0(i+)" ? "N0(i%2B)" : n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}`)
              .then(async (res: any) => {
                stageObj["stage"] = res
                getStage(`/staging-data?cancerType=${cancerName.trim()}&otherStaging=${figo}&histopathology=${data[`histopathology_${suffix}`]}`)
                  .then(async (res1: any) => {
                    stageObj["figoStage"] = res1
                    resolve({ stage: stageObj, suffix: suffix })
                  })
                  .catch((err: any) => {
                    stageObj["figoStage"] = ""
                    resolve({ stage: stageObj, suffix: suffix })
                  })
              })
              .catch((err: any) => {
                console.log(err)
                stageObj["stage"] = ""
                resolve({ stage: stageObj, suffix: suffix })
              })
          })
        } else {
          return new Promise(function (resolve, reject) {
            resolve({ stage: { stage: "", figoStage: "" }, suffix: suffix })
          })
        }
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: { stage: "", figoStage: "" }, suffix: suffix })
        })
      }
    }
    else if (suffix === "TesticularCancer") {
      if (Object.keys(options).length >= 4 && (
        t && n && m && serumMarkers
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&sValue=${serumMarkers}&stagingType=PATHOLOGICAL`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "NET") {
      if (Object.keys(options).length >= 3 && (
        t && n && m
      ) && site) {

        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=Neuroendocrine Tumour&tValue=${t}&nValue=${n}&mValue=${m}&location=${site}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "HeadAndNeckCancer") {
      const stageObj = { cStage: "", pStage: "" }
      if (options["csStage_HeadAndNeckCancer"]) {
        stageObj["cStage"] = options["csStage_HeadAndNeckCancer"]
      }
      if (options["psStage_HeadAndNeckCancer"]) {
        stageObj["pStage"] = options["psStage_HeadAndNeckCancer"]
      }
      if (Object.keys(options).length >= 3) {
        if (!(tp && np && mp) && (tc && nc && mc) && site) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=Head And Neck Cancer&tValue=${tc}&nValue=${nc}&mValue=${mc}&location=${site}`)
              .then(async (res: any) => {
                const temp = { cStage: res, pStage: "" }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                stageObj["cStage"] = ""
                resolve({ stage: stageObj, suffix: suffix })
              })
          })
        } else if ((tp && np && mp) && !(tc && nc && mc) && site) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=Head And Neck Cancer&tValue=${tp}&nValue=${np}&mValue=${mp}&location=${site}`)
              .then(async (res: any) => {
                const temp = { cStage: "", pStage: res }
                resolve({ stage: temp, suffix: suffix })
              })
              .catch((err: any) => {
                console.log(err)
                stageObj["pStage"] = ""
                resolve({ stage: stageObj, suffix: suffix })
              })
          })
        } else if ((tp && np && mp) && (tc && nc && mc) && site) {
          return new Promise(function (resolve, reject) {
            getStage(`/staging-data?cancerType=Head And Neck Cancer&tValue=${tc}&nValue=${nc}&mValue=${mc}&location=${site}`)
              .then(async (res1: any) => {
                getStage(`/staging-data?cancerType=Head And Neck Cancer&tValue=${tp}&nValue=${np}&mValue=${mp}&location=${site}`)
                  .then(async (res2: any) => {
                    const temp = { cStage: res1, pStage: res2 }
                    resolve({ stage: temp, suffix: suffix })
                  })
                  .catch((err: any) => {
                    stageObj["pStage"] = ""
                    resolve({ stage: stageObj, suffix: suffix })
                  })
              })
              .catch((err: any) => {
                console.log(err)
                stageObj["cStage"] = ""
                resolve({ stage: stageObj, suffix: suffix })
              })
          })
        } else {
          return new Promise(function (resolve, reject) {
            const temp = { cStage: "", pStage: "" }
            resolve({ stage: temp, suffix: suffix })
          })
        }
      } else {
        return new Promise(function (resolve, reject) {
          const temp = { cStage: "", pStage: "" }
          resolve({ stage: temp, suffix: suffix })
        })
      }
    }
    else if (suffix === "SoftTissueSarcoma") {
      if (Object.keys(options).length >= 4 && (
        t && n && m && g && site
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&gValue=${g}&location=${site}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (
      // suffix === "Unknown" ||
      // suffix === "Other" ||
      suffix === "BoneSarcoma") {
      if (Object.keys(options).length >= 4 && (
        t && n && m && g
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&gValue=${g}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "LungCancer") {
      if (Object.keys(options).length >= 3 && (
        t && n && m && data[`histopathology_${suffix}`]
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&histopathology=${data[`histopathology_${suffix}`]}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "GIST") {
      if (Object.keys(options).length >= 4 && (
        (t && n && m && mitoticrate && site)
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=GIST&tValue=${t}&nValue=${n}&mValue=${m}&mitoticRate=${mitoticrate}&location=${site}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "Multiple") {
      let otherStaging = prefix === "clinicalStaging" ? options?.issStaging_Multiple_Myeloma : options?.rissStaging_Multiple_Myeloma
      let stagingType = prefix === "clinicalStaging" ? "ISS" : "RISS"

      if (Object.keys(options).length >= 1 && (
        otherStaging && stagingType
      )) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=Multiple Myeloma&stagingType=${stagingType}&otherStaging=${otherStaging}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "BcellNHL" || suffix === "TcellNHL") {
      if (Object.keys(options).length >= 1 && arbor) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${suffix === "BcellNHL" ? "B-Cell Lymphoma" : "T-Cell Lymphoma"}&otherStaging=${arbor}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "WilmsTumor") {
      if (Object.keys(options).length >= 1 && (options?.csCogStaging_WilmsTumor || options?.psCogStaging_WilmsTumor)) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&otherStaging=${prefix === "clinicalStaging" ? options?.csCogStaging_WilmsTumor : options?.psCogStaging_WilmsTumor}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "CLLSLL") {
      const stageObj = { raiStage: "", binetStage: "" }
      if (options?.raiStage_CLLSLL) {
        stageObj["raiStage"] = options?.raiStage_CLLSLL
      }
      if (options?.binetStage_CLLSLL) {
        stageObj["binetStage"] = options?.raiStage_CLLSLL
      }

      if (Object.keys(options).length > 0) {
        if (data[`histopathology_${suffix}`] === "CLL") {
          if (options["raiSystem_CLLSLL"] && !options["binetSystem_CLLSLL"]) {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Chronic lymphocytic leukemia / Small lymphocytic lymphoma&otherStaging=${options["raiSystem_CLLSLL"]}&histopathology=${data[`histopathology_${suffix}`]}`)
                .then(async (res: any) => {
                  const temp = { ...stageObj, ...{ raiStage: res, binetStage: "" } }
                  resolve({ stage: temp, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  const temp = { ...stageObj, ...{ raiStage: "", binetStage: "" } }
                  resolve({ stage: temp, suffix: suffix })
                })
            })
          } else if (options["binetSystem_CLLSLL"] && !options["raiSystem_CLLSLL"]) {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Chronic lymphocytic leukemia / Small lymphocytic lymphoma&otherStaging=${options["binetSystem_CLLSLL"]}&histopathology=${data[`histopathology_${suffix}`]}`)
                .then(async (res: any) => {
                  const temp = { ...stageObj, ...{ binetStage: res, raiStage: "" } }
                  resolve({ stage: temp, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  const temp = { ...stageObj, ...{ raiStage: "", binetStage: "" } }
                  resolve({ stage: temp, suffix: suffix })
                })
            })
          } else if (options["binetSystem_CLLSLL"] && options["raiSystem_CLLSLL"]) {
            const temp = { ...stageObj }
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Chronic lymphocytic leukemia / Small lymphocytic lymphoma&otherStaging=${options["binetSystem_CLLSLL"]}&histopathology=${data[`histopathology_${suffix}`]}`)
                .then(async (res: any) => {
                  temp["binetStage"] = res
                  getStage(`/staging-data?cancerType=Chronic lymphocytic leukemia / Small lymphocytic lymphoma&otherStaging=${options["raiSystem_CLLSLL"]}&histopathology=${data[`histopathology_${suffix}`]}`)
                    .then((res: any) => {
                      temp["raiStage"] = res
                      resolve({ stage: temp, suffix: suffix })
                    })
                    .catch((err: any) => {
                      temp["raiStage"] = ""
                      resolve({ stage: temp, suffix: suffix })
                    })
                })
                .catch((err: any) => {
                  temp["binetStage"] = ""
                  resolve({ stage: temp, suffix: suffix })
                })
            })
          } else if (!options["raiSystem_CLLSLL"]) {
            return new Promise(function (resolve, reject) {
              const temp = { ...stageObj, ...{ raiStage: "" } }
              resolve({ stage: temp, suffix: suffix })
            })
          } else if (!options["binetSystem_CLLSLL"]) {
            return new Promise(function (resolve, reject) {
              const temp = { ...stageObj, ...{ binetStage: "" } }
              resolve({ stage: temp, suffix: suffix })
            })
          }
        } else {
          if (options["sllStagingSystem_CLLSLL"]) {
            return new Promise(function (resolve, reject) {
              getStage(`/staging-data?cancerType=Chronic lymphocytic leukemia / Small lymphocytic lymphoma&otherStaging=${options["sllStagingSystem_CLLSLL"]}&histopathology=${data[`histopathology_${suffix}`]}`)
                .then(async (res: any) => {
                  resolve({ stage: res, suffix: suffix })
                })
                .catch((err: any) => {
                  console.log(err)
                  resolve({ stage: "", suffix: suffix })
                })
            })
          } else {
            return new Promise(function (resolve, reject) {
              resolve({ stage: "", suffix: suffix })
            })
          }
        }
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else if (suffix === "ProstateCancer") {
      const psa = prefix === "clinicalStaging" ? options["csPSA_ProstateCancer"] : options["psPSA_ProstateCancer"]
      const grade = prefix === "clinicalStaging" ? options["csGradeGroup_ProstateCancer"] : options["psGradeGroup_ProstateCancer"]
      if (Object.keys(options).length >= 5 && (t && n && m && psa && data["gleasonScore_ProstateCancer"] && data["gleasonPattern_ProstateCancer"])) {
        return new Promise(function (resolve, reject) {
          getStage(`/staging-data?cancerType=${cancerName.trim()}&tValue=${t}&nValue=${n}&mValue=${m}&psa=${psa}&gradeGroup=${grade}&stagingType=${type}`)
            .then(async (res: any) => {
              resolve({ stage: res, suffix: suffix })
            })
            .catch((err: any) => {
              console.log(err)
              resolve({ stage: "", suffix: suffix })
            })
        })
      } else {
        return new Promise(function (resolve, reject) {
          resolve({ stage: "", suffix: suffix })
        })
      }
    }
    else {
      return { stage: "", suffix: suffix }
    }
  }

  function getNutritionalAvgScore(options: any, name: any, survey: any) {
    let data = survey?.data
    if (Object.keys(data)?.length > 0) {
      let score = 0
      let count = 0
      Object.keys(data)?.forEach((key: any) => {
        if (
          key === "weightLossRating" ||
          key === "dietaryIntakeRating" ||
          key === "nauseaRating" ||
          key === "vomitingRating" ||
          key === "diarrhea" ||
          key === "functionalStatusRating" ||
          key === "diseaseStateAffectingNutritionalRequirementsRating" ||
          key === "muscleWastageRating" ||
          key === "fatStoresRating" ||
          key === "edemaRating"
        ) {
          score += Number(data[key])
          count += 1
        }
      })
      const finalScore = score / count
      return Math.round(finalScore)
    } else {
      return ""
    }
  }

  function calculateBMI(options: any, name: any, survey: any) {
    const data = survey?.data
    let bmi
    if (data?.Height && data?.Weight) {
      if (!(data?.Height === "0" && data?.Weight === "0")) {
        if (
          !(isNaN(Number(data?.Height)) && isNaN(Number(data?.Weight)))
        ) {
          bmi =
            Number(data?.Weight) /
            Math.pow(Number(data?.Height) / 100, 2)

          bmi = isNaN(bmi) ? 0 : Math.round((bmi + Number.EPSILON) * 100) / 100
        }
      }
    }
    return bmi
  }

  function getDietPlanData(options: any, name: any, survey: any) {
    const dataObj = survey?.data
    switch (dataObj?.DietPlan) {
      case "Balanced Diet":
        return {
          BalancedDiet: "Balanced Diet",
          balancedDietCalories: "1400 kcal",
          balancedDietProteins: "50 gm",
          balancedDietFat: "15 ml",
          balancedDietBreakfast: "Breakfast",
          balancedDietBreakfastTime: "8 am",
          balancedDietBreakfastMenu: `One cup vegetable upma/Poha \nOR One cup oats porridge \nOR Two khakhra /Chapati With One cup milk/One egg preparation \nOR Two medium idlis/Dosa/one uttapam with One cup sambar`,
          balancedDietMidmorning: "Mid morning",
          balancedDietMidmorningTime: "10am",
          balancedDietMidmorningMenu: "One fruit (Stewed/Freshly cut/Thick skinned) + 3-4 pcs almonds and walnuts",
          balancedDietLunch: "Lunch",
          balancedDietLunchTime: "12-1pm",
          balancedDietLunchMenu: `One cup cooked vegetables \nOne cup rice/ Two Phulkas/Two small jowar or bajra roti \nOne cup Dal/Pulses/Soya/Chicken/Fish (50 gm- Non fried) \nOne cup curd/ 50gm Paneer`,
          balancedDietSnacks: "Snacks",
          balancedDietSnacksTime: "4 pm",
          balancedDietSnacksMenu: `One cup tea  With One cup roasted kurmura/makhana/Homemade Poha chiwda \nOR Two khakhra \nOR One cup roasted makhana`,
          balancedDietLateEvening: "Late Evening",
          balancedDietLateEveningTime: "6-7pm",
          balancedDietLateEveningMenu: "One bowl dal vegetable soup/One glass buttermilk",
          balancedDietDinner: "Dinner",
          balancedDietDinnerTime: "8.30-9.30 pm",
          balancedDietDinnerMenu: `Same as lunch  \nOR  One paneer stuffed paratha with One cup curd  \nOR One bowl dal vegetable khichdi with One cup curd `,
          balancedDietBedtime: "Bedtime",
          balancedDietBedtimeTime: "10.30-11pm",
          balancedDietBedtimeMenu: "One cup cow’s milk "
        }
      case "High Protein Diet":
        return {
          HighProteinDiet: "High Protein Diet",
          highProteinCalories: "1600 kcal",
          highProteinProteins: "60 gm",
          highProteinFat: "15 ml",
          highProteinDietEarlyMorning: "Early Morning",
          highProteinDietEarlyMorningTime: "8 am",
          highProteinDietEarlyMorningMenu: "One glass cow’s milk /One egg preparation\n+ Soaked (3-4 almonds and walnuts + 2 Anjeer/fig +  3-4  Black Raisins + 2-3 Dates)",
          highProteinDietBreakfast: "Breakfast",
          highProteinDietBreakfastTime: "9:30 am",
          highProteinDietBreakfastMenu: "One Cup Tea ( Cow’s Milk )\nwith One cup vegetable Poha\nOR One cup vegetable  Upma ( oats/ Daliya/rawa/Sevai)\nOR Two medium idli /dosa/One Uttapam with cooked tomato or corriander chutney\nOR  One medium Mix Veg Paratha\nOR  Two medium Thepla ",
          highProteinDietMidmorning: "Midmorning",
          highProteinDietMidmorningTime: "11:30am",
          highProteinDietMidmorningMenu: "1 Medium Fruit\n(Boiled OR washed with hot water & cut peeled OR Thick skin fruit) ",
          highProteinDietLunch: "Lunch",
          highProteinDietLunchTime: "1:30 pm",
          highProteinDietLunchMenu: "Two Phulka ( without Oil) OR One cup rice\n+ One cup vegetable\n+ One cup thick Dal/Pulses/ sprouts/Soya\nOR 2 Medium pcs Chicken/fish/1 egg Preparation (Not fried)\nOR Paneer preparation (50gm/3-4 pcs)",
          highProteinDietAfternoon: "Afternoon",
          highProteinDietAfternoonTime: "2:00 pm ",
          highProteinDietAfternoonMenu: "One cup Curd OR One Glass Buttermilk\n(Use amchur powder/Roasted Jeera powder instead of salt/sugar/chaat masala) ",
          highProteinDietEveningSnacks: "Evening Snacks",
          highProteinDietEveningSnacksTime: "5:00 pm",
          highProteinDietEveningSnacksMenu: "One cup Tea ( Cow’s Milk )\nwith One Handful Roasted Chana/ Boiled Sprouts\nOR Two vegetable Besan or moong dal Chillas\nOR 3-4 pcs Yellow Dhokla / 3-4 pcs Khandvi",
          highProteinDietLateEvening: "Late evening ",
          highProteinDietLateEveningTime: "7:00 pm",
          highProteinDietLateEveningMenu: "1 bowl Mix Vegetable dal Soup\n(Add 1 tablespoon Moong dal while cooking vegetable) ",
          highProteinDietDinner: "Dinner ",
          highProteinDietDinnerTime: "8:30 pm",
          highProteinDietDinnerMenu: "Same as lunch with one cup Curd OR One Glass Buttermilk\nOR\nOne Bowl mix vegetable dal khichdi (Rice/Daliya)+ 1 bowl kadhi + one cup Curd/ One Glass Buttermilk\nOR\nOne medium Bajra/Ragi roti with 1 Katori vegetable with 1 Katori Dal + one cup Curd/ One Glass Buttermilk",
          highProteinDietBedTime: "Bed Time",
          highProteinDietBedTimeTime: "10:30pm ",
          highProteinDietBedTimeMenu: "One glass cow’s Milk "
        }
      case "High Protein Diet 2":
        return {
          "HighProteinDiet2": "High Protein Diet 2",
          "highProteinCalories2": "1800 kcal",
          "highProteinProteins2": "70 gm",
          "highProteinFat2": "15 ml",
          "highProteinDietEarlyMorning2": "Early morning",
          "highProteinDietEarlyMorningTime2": "8 am",
          "highProteinDietEarlyMorningMenu2": "One glass cow’s milk With Soaked (3-4 almonds and walnuts + 2 Anjeer +  3-4  Black Raisins + 2-3 Dates)",
          "highProteinDietBreakfast2": "Breakfast",
          "highProteinDietBreakfastTime2": "9:30 am",
          "highProteinDietBreakfastMenu2": "One Cup Tea ( Cow’s Milk ) with One cup vegetable Poha\nOR One cup vegetable  Upma ( oats/ Daliya/rawa/Sevai)\nOR Two medium idli / 1 dosa/1 Uttapam with Cooked tomato or Corriander chutney\nOR  One medium Mix Veg Paratha\nOR  One medium Thepla +  One egg preparation/One cup boiled moong/sprouts",
          "highProteinDietMidmorning2": "Midmorning ",
          "highProteinDietMidmorningTime2": "11:30am",
          "highProteinDietMidmorningMenu2": "One Medium Fruit\n(Boiled OR washed with hot water & cut peeled OR Thick skin fruit)",
          "highProteinDietLunch2": "Lunch",
          "highProteinDietLunchTime2": "1:30 pm",
          "highProteinDietLunchMenu2": "Two Phulka ( without Oil) + One cup rice + One cup vegetable + One cup thick Dal/Pulses/ sprouts/Soya\nOR 2 Medium pcs Chicken/fish/1 egg Preparation (Not fried)\nOR Paneer preparation (50gm/3-4 pcs)",
          "highProteinDietAfternoon2": "Afternoon",
          "highProteinDietAfternoonTime2": "2:00 pm ",
          "highProteinDietAfternoonMenu2": "One cup curd OR One Glass Buttermilk (Use amchur powder/Roasted Jeera powder instead of salt/sugar/chaat masala)",
          "highProteinDietEveningSnacks2": "Evening Snacks",
          "highProteinDietEveningSnacksTime2": "5:00 pm",
          "highProteinDietEveningSnacksMenu2": "One cup Tea ( Cow’s Milk ) with One Handful Roasted Chana/ Boiled Sprouts\nOR Two vegetable Besan or moong dal Chillas\nOR 3-4 pcs Yellow Dhokla / 3-4 pcs Khandvi",
          "highProteinDietLateEvening2": "Late evening ",
          "highProteinDietLateEveningTime2": "7:00 pm",
          "highProteinDietLateEveningMenu2": "One bowl Mix Vegetable Soup (Add 1 tablespoon Moong dal while cooking vegetable)",
          "highProteinDietDinner2": "Dinner ",
          "highProteinDietDinnerTime2": "8:30 pm",
          "highProteinDietDinnerMenu2": "Same as lunch + One cup curd One Bowl mix vegetable dal khichdi (Rice/Daliya)+ 1 bowl kadhi + one cup Curd/ One Glass Buttermilk\nOR One medium Bajra/Ragi roti with One cup vegetable with One cup Dal + one cup Curd/ One Glass Buttermilk",
          "highProteinDietBedTime2": "Bed Time",
          "highProteinDietBedTimeTime2": "10:30pm ",
          "highProteinDietBedTimeMenu2": "One glass cow’s Milk ",
          "DietPlan": "High Protein Diet 2"
        }
      case "Renal Diet":
        return {
          RenalDiet: "Renal Diet",
          renalDietCalories: "1400 kcal",
          renalDietProteins: "50 gm",
          renalDietFat: "15 ml",
          renalDietFFD: "600 ml",
          renalDietBreakfast: "Breakfast",
          renalDietBreakfastTime: "8 am",
          renalDietBreakfastMenu: "One cup vegetable upma/Poha\nOR Two khakhra /Chapati With One cup cow’s milk(150ml)/One egg preparation\nOR  Two medium idlis/Dosa/One uttapam with One cup sambar ",
          renalDietMidmorning: "Midmorning",
          renalDietMidmorningTime: "10am",
          renalDietMidmorningMenu: "100-150 fruit\n(Stewed/Freshly cut-Guava, Pear, Papaya, Pineapple, Apple)",
          renalDietLunch: "Lunch",
          renalDietLunchTime: "12.30-1.30 pm",
          renalDietLunchMenu: "One cup cooked vegetables\nOne cup rice/ Two Phulkas\nOne cup Dal(100ml)/ Chicken/Fish (2medium pcs- Non fried, Once a week)\nOne big cup hungcurd/ 60gm Paneer",
          renalDietSnacks: "Snacks",
          renalDietSnacksTime: "4 pm",
          renalDietSnacksMenu: "One cup tea (100ml)\nWith One cup roasted kurmura/roasted Poha chiwda/Makhana/2 khakhra",
          renalDietDinner: "Dinner",
          renalDietDinnerTime: "8.30-9.30 pm",
          renalDietDinnerMenu: "One cup cooked vegetables\nOne cup rice/ Two Phulkas\nOne cup Dal(100ml)/ Chicken/Fish (50 gm- Non fried, Once a week)\nOne big cup hungcurd/ 60gm Paneer",
          renalDietBedTime: "Bed Time",
          renalDietBedTimeTime: "10:30pm ",
          renalDietBedTimeMenu: "One cup cow’s milk (150ml)"
        }
      case "RT feed":
        return {
          RTFeed: "RT Feed",
          rtFeedCalories: "848 Kcal",
          rtFeedProteins: "40.9 gm",
          rtFeedFat: "18.5 gm",
          rtFeedMealOneTime: "6 am",
          rtFeedMealOneQuantity: "200 ml ",
          rtFeedMealOneFeed: "Water + ",
          rtFeedMealTwoTime: "8 am",
          rtFeedMealTwoQuantity: "200 ml ",
          rtFeedMealTwoMenu: "Milk + ",
          rtFeedMealThreeTime: "10 am",
          rtFeedMealThreeQuantity: "200 ml",
          rtFeedMealThreeMenu: "150 grams stewed apple pureed",
          rtFeedMealFourTime: "12 pm",
          rtFeedMealFourQuantity: "200 ml",
          rtFeedMealFourMenu: "Chapati 30 grams + dal 30 grams Pureed ",
          rtFeedMealFiveTime: "2 pm",
          rtFeedMealFiveQuantity: "200 ml",
          rtFeedMealFiveMenu: "Dal 100 grams pureed ",
          rtFeedMealSixTime: "4 pm",
          rtFeedMealSixQuantity: "200 ml",
          rtFeedMealSixMenu: "Dal pani/Moong pani + ",
          rtFeedMealSevenTime: "6 pm",
          rtFeedMealSevenQuantity: "200 ml",
          rtFeedMealSevenMenu: "Clear mix. Veg soup/Rice Kanji+",
          rtFeedMealEightTime: "8 pm",
          rtFeedMealEightQuantity: "200 ml",
          rtFeedMealEightMenu: "Rice 40 grams + dal 60 grams pureed ",
          rtFeedMealNineTime: "10 pm",
          rtFeedMealNineQuantity: "200 ml",
          rtFeedMealNineMenu: "Milk + "
        }
      case "Full Liquid Diet":
        return {
          FullLiquidDiet: "Full Liquid Diet",
          fullLiquidDietCalories: "700 Kcal",
          fullLiquidDietProteins: "25 gm",
          fullLiquidDietMealOneTime: "6 am",
          fullLiquidDietMealOneQuantity: "200 ml ",
          fullLiquidDietMealOneFeed: "Barley water",
          fullLiquidDietMealTwoTime: "8 am",
          fullLiquidDietMealTwoQuantity: "200 ml ",
          fullLiquidDietMealTwoMenu: "Milk/Soyamilk",
          fullLiquidDietMealThreeTime: "10 am",
          fullLiquidDietMealThreeQuantity: "200 ml",
          fullLiquidDietMealThreeMenu: "Fruit milkshake/smoothie/Fruit juice",
          fullLiquidDietMealFourTime: "12 pm",
          fullLiquidDietMealFourQuantity: "200 ml",
          fullLiquidDietMealFourMenu: "Rice kanji",
          fullLiquidDietMealFiveTime: "2 pm",
          fullLiquidDietMealFiveQuantity: "200 ml",
          fullLiquidDietMealFiveMenu: "Buttermilk",
          fullLiquidDietMealSixTime: "4 pm",
          fullLiquidDietMealSixQuantity: "200 ml",
          fullLiquidDietMealSixMenu: "Clear mix veg soup ",
          fullLiquidDietMealSevenTime: "6 pm",
          fullLiquidDietMealSevenQuantity: "200 ml",
          fullLiquidDietMealSevenMenu: "Moong pani ",
          fullLiquidDietMealEightTime: "8 pm",
          fullLiquidDietMealEightQuantity: "200 ml",
          fullLiquidDietMealEightMenu: "Dal soup ",
          fullLiquidDietMealNineTime: "10 pm",
          fullLiquidDietMealNineQuantity: "200 ml",
          fullLiquidDietMealNineMenu: "Milk/Soyamilk"
        }
      default:
        return {}
    }
  }

  function getRiskData(options: any, name: any, survey: any) {
    const dataObj = survey?.data

    if (
      dataObj?.spleenBelowCostalMargin_CML &&
      dataObj?.platelets_CML &&
      dataObj?.blastPercent_CML &&
      dataObj?.peripheralBloodBlast_CML &&
      dataObj?.peripheralBloodEosinophils_CML &&
      dataObj?.peripheralBloodBasophils_CML
    ) {
      let sokalScore = 0

      const p1 = 0.0116 * (patientInfo?.age - 43.4)
      const p2 = 0.0345 * (dataObj?.spleenBelowCostalMargin_CML - 7.51)
      const p3 = 0.188 * (Math.pow(dataObj?.platelets_CML / 700, 2) - 0.563)
      const p4 = 0.0887 * (dataObj?.blastPercent_CML - 2.10)

      sokalScore += Math.exp(p1 + p2 + p3 + p4)

      const hasfordScore = (0.6666 * (Number(patientInfo?.age) < 50 ? 0 : 1) + 0.042 * (Number(dataObj?.spleenBelowCostalMargin_CML)) + 0.0584 * Number(dataObj?.blastPercent_CML) + 0.0413 * Number(dataObj?.peripheralBloodEosinophils_CML) + 0.2039 * (Number(dataObj?.peripheralBloodBasophils_CML) < 3 ? 1 : 0) + 1.0956 * (Number(dataObj?.platelets_CML) < 1500 ? 0 : 1)) * 1000

      const eltsScore = 0.0025 * Math.pow((Number(patientInfo?.age) / 10), 3) + 0.0615 * Number(dataObj?.spleenBelowCostalMargin_CML) + 0.1052 * Number(dataObj?.peripheralBloodBlast_CML) + 0.4104 * Math.pow((Number(dataObj?.platelets_CML) / 1000), 0.5)

      let sokalRiskGroup, hasfordRiskGroup, eLTSRiskGroup

      //Sokal Risk Group
      if (sokalScore < 0.8) {
        sokalRiskGroup = "Low"
      } else if (sokalScore > 0.8 && sokalScore < 1.2) {
        sokalRiskGroup = "Intermediate"
      } else {
        sokalRiskGroup = "High"
      }

      //Hasford Risk Group
      if (hasfordScore <= 780) {
        hasfordRiskGroup = "Low"
      } else if (hasfordScore > 780 && hasfordScore <= 1480) {
        hasfordRiskGroup = "Intermediate"
      } else {
        hasfordRiskGroup = "High"
      }

      //elts Risk Group
      if (eltsScore <= 1.5680) {
        eLTSRiskGroup = "Low"
      } else if (eltsScore > 1.5680 && eltsScore <= 2.2185) {
        eLTSRiskGroup = "Intermediate"
      } else {
        eLTSRiskGroup = "High"
      }

      return {
        sokalScore_CML: sokalScore.toFixed(2),
        sokalRiskGroup_CML: sokalRiskGroup,
        hasfordScore_CML: hasfordScore.toFixed(2),
        hasfordRiskGroup_CML: hasfordRiskGroup,
        eLTSScore_CML: eltsScore.toFixed(2),
        eLTSRiskGroup_CML: eLTSRiskGroup
      }
    } else if (
      dataObj?.spleenBelowCostalMargin_CML &&
      dataObj?.platelets_CML &&
      dataObj?.blastPercent_CML
    ) {
      let sokalScore = 0

      const p1 = 0.0116 * (patientInfo?.age - 43.4)
      const p2 = 0.0345 * (dataObj?.spleenBelowCostalMargin_CML - 7.51)
      const p3 = 0.188 * (Math.pow(dataObj?.platelets_CML / 700, 2) - 0.563)
      const p4 = 0.0887 * (dataObj?.blastPercent_CML - 2.10)

      sokalScore += Math.exp(p1 + p2 + p3 + p4)

      const hasfordScore = ""

      const eltsScore = ""

      let sokalRiskGroup, hasfordRiskGroup, eLTSRiskGroup = ""

      //Sokal Risk Group
      if (sokalScore < 0.8) {
        sokalRiskGroup = "Low"
      } else if (sokalScore > 0.8 && sokalScore < 1.2) {
        sokalRiskGroup = "Intermediate"
      } else {
        sokalRiskGroup = "High"
      }

      return {
        sokalScore_CML: sokalScore.toFixed(2),
        sokalRiskGroup_CML: sokalRiskGroup,
        hasfordScore_CML: hasfordScore,
        hasfordRiskGroup_CML: hasfordRiskGroup,
        eLTSScore_CML: eltsScore,
        eLTSRiskGroup_CML: eLTSRiskGroup
      }
    } else {
      return {
        sokalScore_CML: "",
        sokalRiskGroup_CML: "",
        hasfordScore_CML: "",
        hasfordRiskGroup_CML: "",
        eLTSScore_CML: "",
        eLTSRiskGroup_CML: ""
      }
    }
  }

  function getRiskDataWilmsTumor(options: any, name: any, survey: any) {
    const dataObj = survey?.data
    let initialRisk, finalRisk = ""
    const stage = dataObj["clinicalStaging_WilmsTumor"][0]["csStage_WilmsTumor"]
    if (
      dataObj?.patientAge_WilmsTumor &&
      dataObj?.tumorWeight_WilmsTumor &&
      dataObj?.loh1p16q_WilmsTumor &&
      dataObj?.lungMetastasesResponse_WilmsTumor &&
      dataObj?.extraPulmonaryMetastases_WilmsTumor &&
      stage &&
      dataObj?.initialRiskGroup_WilmsTumor
    ) {
      const loh = dataObj?.loh1p16q_WilmsTumor
      const lungMetastasesResponse = dataObj?.lungMetastasesResponse_WilmsTumor
      const extraPulmonaryMetastases = dataObj?.extraPulmonaryMetastases_WilmsTumor
      const irisk = dataObj?.initialRiskGroup_WilmsTumor

      if (irisk === "Very Low" && (loh === "Yes" || loh === "No") && lungMetastasesResponse === "NA" && extraPulmonaryMetastases === "NA") {
        initialRisk = irisk
        finalRisk = "Very Low"
      } else if (
        irisk === "Low" && loh === "No" && lungMetastasesResponse === "NA" && extraPulmonaryMetastases === "NA") {
        initialRisk = irisk
        finalRisk = "Low"
      } else if (
        (irisk === "Low" && loh === "Yes" && lungMetastasesResponse === "NA" && extraPulmonaryMetastases === "NA") ||
        (irisk === "Standard" && loh === "No" && lungMetastasesResponse === "NA" && extraPulmonaryMetastases === "NA") ||
        (irisk === "Higher" && loh === "No" && lungMetastasesResponse === "Complete" && extraPulmonaryMetastases === "No")) {
        initialRisk = irisk
        finalRisk = "Standard"
      } else if (irisk === "Bilateral") {
        initialRisk = irisk
        finalRisk = "Bilateral"
      } else {
        initialRisk = irisk
        finalRisk = "Higher"
      }
    } else if (dataObj?.patientAge_WilmsTumor &&
      dataObj?.tumorWeight_WilmsTumor &&
      stage) {
      const age = dataObj?.patientAge_WilmsTumor
      const tumorWeight = dataObj?.tumorWeight_WilmsTumor

      if (age === "< 2 years" && tumorWeight === "< 550 g" && stage ===
        "Stage I") {
        initialRisk = "Very Low"
      } else if (
        ((age === "< 2 years" || age === ">= 2 years") && tumorWeight === ">= 500 g" && stage === "Stage I") ||
        (age === ">= 2 years" && (tumorWeight === ">= 500 g" || tumorWeight === "< 550 g") && stage === "Stage I") ||
        ((age === "< 2 years" || age === ">= 2 years") && (tumorWeight === ">= 500 g" || tumorWeight === "< 550 g") && stage === "Stage II")) {
        initialRisk = "Low"
      } else if (((age === "< 2 years" || age === ">= 2 years") && (tumorWeight === ">= 500 g" || tumorWeight === "< 550 g") && stage === "Stage III")) {
        initialRisk = "Standard"
      } else if (((age === "< 2 years" || age === ">= 2 years") && (tumorWeight === ">= 500 g" || tumorWeight === "< 550 g") && stage === "Stage IV")) {
        initialRisk = "Higher"
      } else if (((age === "< 2 years" || age === ">= 2 years") && (tumorWeight === ">= 500 g" || tumorWeight === "< 550 g") && stage === "Stage V")) {
        initialRisk = "Bilateral"
      }
    } else {
      initialRisk = ""
      finalRisk = ""
    }
    return {
      initialRiskGroup_WilmsTumor: initialRisk,
      riskStratification_WilmsTumor: finalRisk
    }
  }

  function handleValidateVitals(survey: any, options: any) {
    const { name } = options.question;
    if (name === 'AlbuminValues') {
      if (options.value !== "" && (Number(options?.value) < 3.5 || Number(options?.value) > 5)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (3.5-5)"
        var element: any = document.querySelector('[data-key="AlbuminValues-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="AlbuminValues-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === "HemoglobinValue") {
      const lowerLimit = patientInfo?.gender?.toLowerCase() === "male" ? 13 : 11.5
      const upperLimit = patientInfo?.gender?.toLowerCase() === "male" ? 18 : 16.5
      if (options.value !== "" && (Number(options?.value) < lowerLimit || Number(options?.value) > upperLimit)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = `Value exceeds the range (${lowerLimit}-${upperLimit})`
        var element: any = document.querySelector('[data-key="HemoglobinValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="HemoglobinValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'HGTValue') {
      if (options.value !== "" && (Number(options?.value) < 70 || Number(options?.value) > 140)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (70-140)"
        var element: any = document.querySelector('[data-key="HGTValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="HGTValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'WBCValue') {
      if (options.value !== "" && (Number(options?.value) < 4500 || Number(options?.value) > 11000)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (4500-11000)"
        var element: any = document.querySelector('[data-key="WBCValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="WBCValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'NeutrophilsValue') {
      if (options.value !== "" && (Number(options?.value) < 2500 || Number(options?.value) > 7000)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (2500-7000)"
        var element: any = document.querySelector('[data-key="NeutrophilsValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="NeutrophilsValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'LympocytesValue') {
      if (options.value !== "" && (Number(options?.value) < 1000 || Number(options?.value) > 4800)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (1000-4800)"
        var element: any = document.querySelector('[data-key="LympocytesValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="LympocytesValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'TotalProteinValue') {
      if (options.value !== "" && (Number(options?.value) < 6 || Number(options?.value) > 8)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (6-8)"
        var element: any = document.querySelector('[data-key="TotalProteinValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="TotalProteinValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'SGPTValue') {
      if (options.value !== "" && (Number(options?.value) < 5 || Number(options?.value) > 35)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (5-35)"
        var element: any = document.querySelector('[data-key="SGPTValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="SGPTValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'SGOTValue') {
      if (options.value !== "" && (Number(options?.value) < 5 || Number(options?.value) > 40)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (5-40)"
        var element: any = document.querySelector('[data-key="SGOTValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="SGOTValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'SodiumValue') {
      if (options.value !== "" && (Number(options?.value) < 130 || Number(options?.value) > 145)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (130-145)"
        var element: any = document.querySelector('[data-key="SodiumValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="SodiumValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'PotassiumValue') {
      if (options.value !== "" && (Number(options?.value) < 3.5 || Number(options?.value) > 5)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (3.5-5)"
        var element: any = document.querySelector('[data-key="PotassiumValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="PotassiumValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'SCreatinineValue') {
      if (options.value !== "" && (Number(options?.value) < 0.5 || Number(options?.value) > 1.2)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (0.5-1.2)"
        var element: any = document.querySelector('[data-key="SCreatinineValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="SCreatinineValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    } else if (name === 'totalBilirubinValue') {
      if (options.value !== "" && (Number(options?.value) < 0.1 || Number(options?.value) > 1.2)) {
        const errorElement = document.createElement("div");
        errorElement.className = "survey-error";
        errorElement.innerHTML = "Value exceeds the range (0.1-1.2)"
        var element: any = document.querySelector('[data-key="totalBilirubinValue-1"]');
        if (element) {
          var childElement: any = element?.getElementsByClassName('survey-error')
          if (childElement?.length < 1) {
            element.appendChild(errorElement);
          }
        }
      }
      else {
        var parentNode = document.querySelector('[data-key="totalBilirubinValue-1"]');
        var childElement: any = parentNode?.getElementsByClassName('survey-error')[0]
        if (childElement) {
          childElement.parentNode.removeChild(childElement);
        }
      }
    }
  }

  const onCurrentPageChanged = (sender: any, options: any) => {
    setPageChanged((prevPageChanged: any) => !prevPageChanged)
  };

  return (
    <Survey.Survey
      // css={css}
      json={json}
      data={dataObj}
      onComplete={onComplete}
      showCompletedPage={false}
      onCurrentPageChanged={onCurrentPageChanged}

      onValueChanged={async (survey: any, options: any) => {
        // console.log(options, "CHANGED")

        //Flag modifier for checking tooltip element inside DOM
        updateFlag && updateFlag(survey?.data, survey)

        let tempObj = { ...survey?.data }
        if (options && (
          options?.name === "clinicalStaging_ColonCancer" ||
          options?.name === "clinicalStaging_AnalCancer" ||
          options?.name === "clinicalStaging_RectumCancer" ||
          options?.name === "clinicalStaging_CervicalCancer" ||
          options?.name === "clinicalStaging_Cholangiocarcinoma" ||
          options?.name === "clinicalStaging_EsophagusAndEsophagogastricJunction" ||
          options?.name === "clinicalStaging_GallBladderCancer" ||
          options?.name === "clinicalStaging_GastricCancer" ||
          options?.name === "clinicalStaging_Melanoma" ||
          options?.name === "clinicalStaging_OvaryCancer" ||
          options?.name === "clinicalStaging_PancreaticCancer" ||
          options?.name === "clinicalStaging_PenileCancer" ||
          options?.name === "clinicalStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma" ||
          options?.name === "clinicalStaging_SmallBowelAdenocarcinoma" ||
          options?.name === "clinicalStaging_VulvarCancer" ||
          options?.name === "clinicalStaging_Hodgkins_Lymphoma" ||
          options?.name === "clinicalStaging_ThyroidCancer" ||
          options?.name === "clinicalStaging_UterineCarcinoma" ||
          options?.name === "clinicalStaging_UterineSarcoma" ||
          options?.name === "clinicalStaging_TesticularCancer" ||
          options?.name === "clinicalStaging_GTN" ||
          options?.name === "clinicalStaging_NET" ||
          // options?.name === "clinicalStaging_UnknownCancer" ||
          options?.name === "clinicalStaging_BladderCancer" ||
          // options?.name === "clinicalStaging_OtherCancer" ||
          options?.name === "clinicalStaging_SoftTissueSarcoma" ||
          options?.name === "tumorDetails_HeadAndNeckCancer" ||
          options?.name === "clinicalStaging_HCC" ||
          options?.name === "clinicalStaging_LungCancer" ||
          options?.name === "clinicalStaging_BoneSarcoma" ||
          options?.name === "clinicalStaging_GIST" ||
          options?.name === "clinicalStaging_Multiple_Myeloma" ||
          options?.name === "clinicalStaging_BreastCancer" ||
          options?.name === "clinicalStaging_BcellNHL" ||
          options?.name === "clinicalStaging_WilmsTumor" ||
          options?.name === "clinicalStaging_RCC" ||
          options?.name === "clinicalStaging_TcellNHL" ||
          options?.name === "clinicalStaging_CLLSLL" ||
          options?.name === "clinicalStaging_ProstateCancer")
        ) {
          if (options?.value && options?.value[0]) {
            let stageValue: any = await fetchStage(options?.value[0], options?.name, survey)
            if (stageValue?.suffix === "ColonCancer" ||
              stageValue?.suffix === "AnalCancer" ||
              stageValue?.suffix === "RectumCancer" ||
              stageValue?.suffix === "CervicalCancer" ||
              stageValue?.suffix === "Cholangiocarcinoma" ||
              stageValue?.suffix === "EsophagusAndEsophagogastricJunction" ||
              stageValue?.suffix === "GallBladderCancer" ||
              stageValue?.suffix === "GastricCancer" ||
              stageValue?.suffix === "Melanoma" ||
              stageValue?.suffix === "OvaryCancer" ||
              stageValue?.suffix === "PancreaticCancer" ||
              stageValue?.suffix === "PenileCancer" ||
              stageValue?.suffix === "Pleural" ||
              stageValue?.suffix === "SmallBowelAdenocarcinoma" ||
              stageValue?.suffix === "VulvarCancer" ||
              stageValue?.suffix === "Hodgkins" ||
              stageValue?.suffix === "ThyroidCancer" ||
              stageValue?.suffix === "UterineCarcinoma" ||
              stageValue?.suffix === "UterineSarcoma" ||
              stageValue?.suffix === "TesticularCancer" ||
              stageValue?.suffix === "GTN" ||
              stageValue?.suffix === "NET" ||
              // stageValue?.suffix === "UnknownCancer" ||
              stageValue?.suffix === "BladderCancer" ||
              // stageValue?.suffix === "OtherCancer" ||
              stageValue?.suffix === "SoftTissueSarcoma" ||
              stageValue?.suffix === "HeadAndNeckCancer" ||
              stageValue?.suffix === "HCC" ||
              stageValue?.suffix === "LungCancer" ||
              stageValue?.suffix === "BoneSarcoma" ||
              stageValue?.suffix === "GIST" ||
              stageValue?.suffix === "Multiple" ||
              stageValue?.suffix === "BreastCancer" ||
              stageValue?.suffix === "BcellNHL" ||
              stageValue?.suffix === "WilmsTumor" ||
              stageValue?.suffix === "RCC" ||
              stageValue?.suffix === "TcellNHL" ||
              stageValue?.suffix === "CLLSLL" ||
              stageValue?.suffix === "ProstateCancer"
            ) {
              if (stageValue?.suffix === "Hodgkins") {
                tempObj["clinicalStaging_Hodgkins_Lymphoma"][0]["csStage_Hodgkins_Lymphoma"] = stageValue?.stage
              } else if (stageValue?.suffix === "Pleural") {
                tempObj["clinicalStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma"][0]["csStage_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma"] = stageValue?.stage
              } else if (stageValue?.suffix === "Multiple") {
                tempObj["clinicalStaging_Multiple_Myeloma"][0]["csStage_Multiple_Myeloma"] = stageValue?.stage
              } else if (stageValue?.suffix === "CLLSLL") {
                if (tempObj[`histopathology_${stageValue?.suffix}`] === "CLL") {
                  tempObj["clinicalStaging_CLLSLL"][0]["raiStage_CLLSLL"] = stageValue?.stage?.raiStage
                  tempObj["clinicalStaging_CLLSLL"][0]["binetStage_CLLSLL"] = stageValue?.stage?.binetStage
                } else {
                  tempObj["clinicalStaging_CLLSLL"][0]["sllStage_CLLSLL"] = stageValue?.stage
                }
              } else if (stageValue?.suffix === "UterineCarcinoma" || stageValue?.suffix === "UterineSarcoma" || stageValue?.suffix === "VulvarCancer" || stageValue?.suffix === "OvaryCancer") {
                tempObj[`clinicalStaging_${stageValue?.suffix}`][0][`csStage_${stageValue?.suffix}`] = stageValue?.stage?.stage
                tempObj[`clinicalStaging_${stageValue?.suffix}`][0][`csFigoStage_${stageValue?.suffix}`] = stageValue?.stage?.figoStage
              } else if (stageValue?.suffix === "HeadAndNeckCancer") {
                tempObj["tumorDetails_HeadAndNeckCancer"][0][`csStage_${stageValue?.suffix}`] = stageValue?.stage?.cStage
                tempObj["tumorDetails_HeadAndNeckCancer"][0][`psStage_${stageValue?.suffix}`] = stageValue?.stage?.pStage
              } else {
                tempObj[`clinicalStaging_${stageValue?.suffix}`][0][`csStage_${stageValue?.suffix}`] = stageValue?.stage
              }

              if (stageValue?.suffix === "CervicalCancer" || stageValue?.suffix === "GTN") {
                tempObj[`clinicalStaging_${stageValue?.suffix}`][0][`csFigoStage_${stageValue?.suffix}`] = stageValue?.stage
              }

              if (stageValue?.suffix === "Cholangiocarcinoma") {
                tempObj[`biopsy_${stageValue?.suffix}`] = survey?.data[`biopsy_${stageValue?.suffix}`]
              }

              if (stageValue?.suffix === "EsophagusAndEsophagogastricJunction" || stageValue?.suffix === "Melanoma" || stageValue?.suffix === "ThyroidCancer" || stageValue?.suffix === "LungCancer") {
                tempObj[`histopathology_${stageValue?.suffix}`] = survey?.data[`histopathology_${stageValue?.suffix}`]
              }
            }
            setDataObj(tempObj)
          }
        } else if (options && (
          options?.name === "pathologicalStaging_ColonCancer" ||
          options?.name === "pathologicalStaging_AnalCancer" ||
          options?.name === "pathologicalStaging_RectumCancer" ||
          options?.name === "pathologicalStaging_CervicalCancer" ||
          options?.name === "pathologicalStaging_Cholangiocarcinoma" ||
          options?.name === "pathologicalStaging_EsophagusAndEsophagogastricJunction" ||
          options?.name === "pathologicalStaging_GallBladderCancer" ||
          options?.name === "pathologicalStaging_GastricCancer" ||
          options?.name === "pathologicalStaging_Melanoma" ||
          options?.name === "pathologicalStaging_OvaryCancer" ||
          options?.name === "pathologicalStaging_PancreaticCancer" ||
          options?.name === "pathologicalStaging_PenileCancer" ||
          options?.name === "pathologicalStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma" ||
          options?.name === "pathologicalStaging_SmallBowelAdenocarcinoma" ||
          options?.name === "pathologicalStaging_VulvarCancer" ||
          options?.name === "pathologicalStaging_Hodgkins_Lymphoma" ||
          options?.name === "pathologicalStaging_ThyroidCancer" ||
          options?.name === "pathologicalStaging_UterineCarcinoma" ||
          options?.name === "pathologicalStaging_UterineSarcoma" ||
          options?.name === "pathologicalStaging_TesticularCancer" ||
          options?.name === "pathologicalStaging_GTN" ||
          options?.name === "pathologicalStaging_NET" ||
          // options?.name === "pathologicalStaging_UnknownCancer" ||
          options?.name === "pathologicalStaging_BladderCancer" ||
          // options?.name === "pathologicalStaging_OtherCancer" ||
          options?.name === "pathologicalStaging_SoftTissueSarcoma" ||
          options?.name === "tumorDetails_HeadAndNeckCancer" ||
          options?.name === "pathologicalStaging_HCC" ||
          options?.name === "pathologicalStaging_LungCancer" ||
          options?.name === "pathologicalStaging_BoneSarcoma" ||
          options?.name === "pathologicalStaging_GIST" ||
          options?.name === "pathologicalStaging_Multiple_Myeloma" ||
          options?.name === "pathologicalStaging_BreastCancer" ||
          options?.name === "pathologicalStaging_BcellNHL" ||
          options?.name === "pathologicalStaging_WilmsTumor" ||
          options?.name === "pathologicalStaging_RCC" ||
          options?.name === "pathologicalStaging_TcellNHL" ||
          options?.name === "pathologicalStaging_CLLSLL" ||
          options?.name === "pathologicalStaging_ProstateCancer")
        ) {
          if (options?.value && options?.value[0]) {
            let stageValue: any = await fetchStage(options?.value[0], options?.name, survey)
            if (stageValue?.suffix === "ColonCancer" ||
              stageValue?.suffix === "AnalCancer" ||
              stageValue?.suffix === "RectumCancer" ||
              stageValue?.suffix === "CervicalCancer" ||
              stageValue?.suffix === "Cholangiocarcinoma" ||
              stageValue?.suffix === "EsophagusAndEsophagogastricJunction" ||
              stageValue?.suffix === "GallBladderCancer" ||
              stageValue?.suffix === "GastricCancer" ||
              stageValue?.suffix === "Melanoma" ||
              stageValue?.suffix === "OvaryCancer" ||
              stageValue?.suffix === "PancreaticCancer" ||
              stageValue?.suffix === "PenileCancer" ||
              stageValue?.suffix === "Pleural" ||
              stageValue?.suffix === "SmallBowelAdenocarcinoma" ||
              stageValue?.suffix === "VulvarCancer" ||
              stageValue?.suffix === "Hodgkins" ||
              stageValue?.suffix === "ThyroidCancer" ||
              stageValue?.suffix === "UterineCarcinoma" ||
              stageValue?.suffix === "UterineSarcoma" ||
              stageValue?.suffix === "TesticularCancer" ||
              stageValue?.suffix === "GTN" ||
              stageValue?.suffix === "NET" ||
              // stageValue?.suffix === "UnknownCancer" ||
              stageValue?.suffix === "BladderCancer" ||
              // stageValue?.suffix === "OtherCancer" ||
              stageValue?.suffix === "SoftTissueSarcoma" ||
              stageValue?.suffix === "HeadAndNeckCancer" ||
              stageValue?.suffix === "HCC" ||
              stageValue?.suffix === "LungCancer" ||
              stageValue?.suffix === "BoneSarcoma" ||
              stageValue?.suffix === "GIST" ||
              stageValue?.suffix === "Multiple" ||
              stageValue?.suffix === "BreastCancer" ||
              stageValue?.suffix === "BcellNHL" ||
              stageValue?.suffix === "WilmsTumor" ||
              stageValue?.suffix === "RCC" ||
              stageValue?.suffix === "TcellNHL" ||
              stageValue?.suffix === "CLLSLL" ||
              stageValue?.suffix === "ProstateCancer"
            ) {
              if (stageValue?.suffix === "Hodgkins") {
                tempObj["pathologicalStaging_Hodgkins_Lymphoma"][0][`psStage_Hodgkins_Lymphoma`] = stageValue?.stage
              } else if (stageValue?.suffix === "Pleural") {
                tempObj["pathologicalStaging_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma"][0][`psStage_Pleural_Mesothelioma_or_Peritoneal_Mesothelioma`] = stageValue?.stage
              } else if (stageValue?.suffix === "Multiple") {
                tempObj["pathologicalStaging_Multiple_Myeloma"][0][`psStage_Multiple_Myeloma`] = stageValue?.stage
              } else if (stageValue?.suffix === "CLLSLL") {
                if (tempObj[`histopathology_${stageValue?.suffix}`] === "CLL") {
                  tempObj["pathologicalStaging_CLLSLL"][0]["raiStage_CLLSLL"] = stageValue?.stage?.raiStage
                  tempObj["pathologicalStaging_CLLSLL"][0]["binetStage_CLLSLL"] = stageValue?.stage?.binetStage
                } else {
                  tempObj["pathologicalStaging_CLLSLL"][0]["sllStage_CLLSLL"] = stageValue?.stage
                }
              } else if (stageValue?.suffix === "UterineCarcinoma" || stageValue?.suffix === "UterineSarcoma" || stageValue?.suffix === "VulvarCancer" || stageValue?.suffix === "OvaryCancer") {
                tempObj[`pathologicalStaging_${stageValue?.suffix}`][0][`psStage_${stageValue?.suffix}`] = stageValue?.stage?.stage
                tempObj[`pathologicalStaging_${stageValue?.suffix}`][0][`psFigoStage_${stageValue?.suffix}`] = stageValue?.stage?.figoStage
              } else if (stageValue?.suffix === "HeadAndNeckCancer") {
                tempObj["tumorDetails_HeadAndNeckCancer"][0][`csStage_${stageValue?.suffix}`] = stageValue?.stage?.cStage
                tempObj["tumorDetails_HeadAndNeckCancer"][0][`psStage_${stageValue?.suffix}`] = stageValue?.stage?.pStage
              } else {
                tempObj[`pathologicalStaging_${stageValue?.suffix}`][0][`psStage_${stageValue?.suffix}`] = stageValue?.stage
              }

              if (stageValue?.suffix === "CervicalCancer" || stageValue?.suffix === "GTN") {
                tempObj[`pathologicalStaging_${stageValue?.suffix}`][0][`psFigoStage_${stageValue?.suffix}`] = stageValue?.stage
              }

              if (stageValue?.suffix === "Cholangiocarcinoma") {
                tempObj[`biopsy_${stageValue?.suffix}`] = survey?.data[`biopsy_${stageValue?.suffix}`]
              }

              if (stageValue?.suffix === "EsophagusAndEsophagogastricJunction" || stageValue?.suffix === "Melanoma" || stageValue?.suffix === "ThyroidCancer" || stageValue?.suffix === "LungCancer") {
                tempObj[`histopathology_${stageValue?.suffix}`] = survey?.data[`histopathology_${stageValue?.suffix}`]
              }
            }
            setDataObj(tempObj)
          }
        } else if (options && options?.name === "pastTreatmentDetails") {
          if (options?.value?.length > 0) {
            options?.value?.forEach(async (obj: any, index: any) => {
              if (options?.value && options?.value[index]) {
                let lesionValue: any = await fetchLesion(options?.value[index], options?.name, survey)
                let data = survey?.data
                if (lesionValue === "NA") {
                  let temp = { ...data }
                  temp.pastTreatmentDetails[index].withTargetLesions[0] = {}
                  temp.pastTreatmentDetails[index].withoutTargetLesions[0] = {}
                  setDataObj(temp)
                } else {
                  if (data?.pastTreatmentDetails[index]?.responseCriteria === "With Target Lesions") {
                    let temp = { ...data }
                    temp.pastTreatmentDetails[index].withTargetLesions[0] = {
                      ...temp.pastTreatmentDetails[index].withTargetLesions[0],
                      ...{ overallResponse: lesionValue }
                    }
                    setDataObj(temp)
                  }
                  else {
                    let temp = { ...data }
                    temp.pastTreatmentDetails[index].withoutTargetLesions[0] = {
                      ...temp.pastTreatmentDetails[index].withoutTargetLesions[0],
                      ...{ overallResponse: lesionValue }
                    }
                    setDataObj(temp)
                  }
                }
              }
            })
          }
        } else if (options && (options?.name === "investigation")) {
          if (options?.value) {
            if (options?.value?.length > 0) {
              const tempValue = [...options?.value]
              tempValue?.forEach(async (e: any, index: any) => {
                const eachItem: any = { ...e }
                const testName: any = e?.test?.replace(/[()/; -]/g, '')
                if (testName) {
                  var regex: any = new RegExp(testName, "i")
                }
                for (const key in e) {
                  if (key !== "dateOfTest" && key !== "test" && key !== "testFindings" && key !== "uploadFile" && key !== "test-Comment" && key !== "aiEnabled") {
                    if (regex) {
                      if (!regex?.test(key)) {
                        delete eachItem[key];
                      }
                    }
                  } else if (key === "uploadFile") {
                    if (e?.uploadFile?.length > 0) {
                      if (!e?.uploadFile[0]?.content?.includes("http")) {
                        //File Data
                        let mediaData = e?.uploadFile[0]
                        //Validation
                        const invalidFile: any = !fileUtils.validateFileExtension(mediaData?.name)
                        if (invalidFile) {
                          eachItem["uploadFile"].length = 0
                          toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
                          return;
                        }
                        //Upload and Update Data Object
                        let response = await fetch(mediaData?.content);
                        let data = await response.blob();
                        let metadata = {
                          type: `${mediaData?.type}`
                        };
                        let file = new File([data], `${mediaData?.name}`, metadata);
                        const formData = new FormData();
                        formData.append('files', file);
                        uploadSpecificFile(formData, true)
                          .then((data: any) => {
                            const fileObj = {
                              name: `${mediaData?.name}`,
                              type: `${mediaData?.type}`,
                              content: data[0]
                            }
                            eachItem["uploadFile"][0] = fileObj
                          })
                          .catch((err: any) => {
                            const errCode = err?.response?.data?.code;
                            if (errCode === 'MaxUploadSizeExceededException') {
                              alert("File Size should be less than 1 MB")
                            }
                            console.log(err, "err in uploading file")
                          })
                      }
                    }
                  }
                }
                tempValue[index] = eachItem
              })
              let tempDataObj: any = { ...survey?.data }
              tempDataObj[`${options?.name}`] = tempValue
              setDataObj(tempDataObj)
              updateFlag(tempDataObj, survey)
            }
          }
        } else if (options && (options?.name === "investigation_Endoscopy")) {
          if (options?.value) {
            if (options?.value?.length > 0) {
              options?.value?.forEach(async (e: any, index: any) => {
                if (!e?.endoscopyUploadFile[0]?.content?.includes("http")) {
                  //File Data
                  let mediaData = e?.endoscopyUploadFile[0]
                  //Validation
                  const invalidFile: any = !fileUtils.validateFileExtension(mediaData?.name)
                  if (invalidFile) {
                    const uploadObj = { ...tempObj }
                    uploadObj[`${options?.name}`][index]["endoscopyUploadFile"].length = 0
                    setDataObj(uploadObj)
                    toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
                    return;
                  }
                  //Upload & Update Data Object
                  let response = await fetch(mediaData?.content);
                  let data = await response.blob();
                  let metadata = {
                    type: `${mediaData?.type}`
                  };
                  let file = new File([data], `${mediaData?.name}`, metadata);
                  const formData = new FormData();
                  formData.append('files', file);
                  uploadSpecificFile(formData, true)
                    .then((data: any) => {
                      const fileObj = {
                        name: `${mediaData?.name}`,
                        type: `${mediaData?.type}`,
                        content: data[0]
                      }
                      const uploadObj = { ...tempObj }
                      uploadObj[`${options?.name}`][index]["endoscopyUploadFile"][0] = fileObj
                      setDataObj(uploadObj)
                    })
                    .catch((err: any) => {
                      const errCode = err?.response?.data?.code;
                      if (errCode === 'MaxUploadSizeExceededException') {
                        alert("File Size should be less than 1 MB")
                      }
                      console.log(err, "err in uploading file")
                    })
                }
              })
            }
          }
        } else if (options && (options?.name === "investigation_LowerGiEndoscopy")) {
          if (options?.value) {
            if (options?.value?.length > 0) {
              options?.value?.forEach(async (e: any, index: any) => {
                if (!e?.lowerGiEndoscopyUploadFile[0]?.content?.includes("http")) {
                  //File Data
                  let mediaData = e?.lowerGiEndoscopyUploadFile[0]
                  //Validation
                  const invalidFile: any = !fileUtils.validateFileExtension(mediaData?.name)
                  if (invalidFile) {
                    const uploadObj = { ...tempObj }
                    uploadObj[`${options?.name}`][index]["lowerGiEndoscopyUploadFile"].length = 0
                    setDataObj(uploadObj)
                    toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
                    return;
                  }
                  //Upload and Update Data Object
                  let response = await fetch(mediaData?.content);
                  let data = await response.blob();
                  let metadata = {
                    type: `${mediaData?.type}`
                  };
                  let file = new File([data], `${mediaData?.name}`, metadata);
                  const formData = new FormData();
                  formData.append('files', file);
                  uploadSpecificFile(formData, true)
                    .then((data: any) => {
                      const fileObj = {
                        name: `${mediaData?.name}`,
                        type: `${mediaData?.type}`,
                        content: data[0]
                      }
                      const uploadObj = { ...tempObj }
                      uploadObj[`${options?.name}`][index]["lowerGiEndoscopyUploadFile"][0] = fileObj
                      setDataObj(uploadObj)
                    })
                    .catch((err: any) => {
                      const errCode = err?.response?.data?.code;
                      if (errCode === 'MaxUploadSizeExceededException') {
                        alert("File Size should be less than 1 MB")
                      }
                      console.log(err, "err in uploading file")
                    })
                }
              })
            }
          }
        } else if (options && (options?.name === "investigation_Colonoscopy")) {
          if (options?.value) {
            if (options?.value?.length > 0) {
              options?.value?.forEach(async (e: any, index: any) => {
                if (!e?.colonoscopyUploadFile[0]?.content?.includes("http")) {
                  //File Data
                  let mediaData = e?.colonoscopyUploadFile[0]
                  //Validation
                  const invalidFile: any = !fileUtils.validateFileExtension(mediaData?.name)
                  if (invalidFile) {
                    const uploadObj = { ...tempObj }
                    uploadObj[`${options?.name}`][index]["colonoscopyUploadFile"].length = 0
                    setDataObj(uploadObj)
                    toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
                    return;
                  }
                  //Upload and Update Data Object
                  let response = await fetch(mediaData?.content);
                  let data = await response.blob();
                  let metadata = {
                    type: `${mediaData?.type}`
                  };
                  let file = new File([data], `${mediaData?.name}`, metadata);
                  const formData = new FormData();
                  formData.append('files', file);
                  uploadSpecificFile(formData, true)
                    .then((data: any) => {
                      const fileObj = {
                        name: `${mediaData?.name}`,
                        type: `${mediaData?.type}`,
                        content: data[0]
                      }
                      const uploadObj = { ...tempObj }
                      uploadObj[`${options?.name}`][index]["colonoscopyUploadFile"][0] = fileObj
                      setDataObj(uploadObj)
                    })
                    .catch((err: any) => {
                      const errCode = err?.response?.data?.code;
                      if (errCode === 'MaxUploadSizeExceededException') {
                        alert("File Size should be less than 1 MB")
                      }
                      console.log(err, "err in uploading file")
                    })
                }
              })
            }
          }
        }
        else if (options && (
          (options?.name === "weightLossRating") ||
          (options?.name === "dietaryIntakeRating") ||
          (options?.name === "nauseaRating") ||
          (options?.name === "vomitingRating") ||
          (options?.name === "diarrhea") ||
          (options?.name === "functionalStatusRating") ||
          (options?.name === "diseaseStateAffectingNutritionalRequirementsRating") ||
          (options?.name === "muscleWastageRating") ||
          (options?.name === "fatStoresRating") ||
          (options?.name === "edemaRating")
        )) {
          const avgScore = getNutritionalAvgScore(options?.value, options?.name, survey)
          if (avgScore !== "") {
            let data = survey?.data
            let temp = { ...data }
            temp["overallSGARating"] = avgScore
            setDataObj(temp)
          }
        }
        else if (options && (
          (options?.name === "Height") ||
          (options?.name === "Weight")
        )) {
          //Calculate BMI
          let res = calculateBMI(options?.value, options?.name, survey)
          if (res) {
            let data = survey?.data
            let temp = { ...data }
            temp["BMI"] = res
            setDataObj(temp)
          }
        }
        else if (options && (
          (options?.name === "DietPlan")
        )) {
          let resData = getDietPlanData(options?.value, options?.name, survey)
          let data = survey?.data
          let temp = { ...resData, ...data }
          setDataObj(temp)
          updateFlag && updateFlag(temp, survey)
        }
        else if (options && (
          (options?.name === "raiseRequestPatientId")
        )) {
          updateCallback(tempObj, options?.value)
        }
        // else if (options && (
        //   (options?.name === "doctorName")
        // )) {
        //   updateSelectedConsultant(tempObj, options?.value)
        // }
        else if (options && (
          (options?.name === "spleenBelowCostalMargin_CML") ||
          (options?.name === "platelets_CML") ||
          (options?.name === "blastPercent_CML") ||
          (options?.name === "peripheralBloodBlast_CML") ||
          (options?.name === "peripheralBloodEosinophils_CML") ||
          (options?.name === "peripheralBloodBasophils_CML")
        )) {
          //Code for risk stratification 
          let resData = getRiskData(options?.value, options?.name, survey)
          let data = survey?.data
          let temp = { ...data, ...resData }
          updateFlag && updateFlag(temp, survey)
          setDataObj(temp)
        }
        else if (options && (
          (options?.name === "patientAge_WilmsTumor") ||
          (options?.name === "tumorWeight_WilmsTumor") ||
          (options?.name === "loh1p16q_WilmsTumor") ||
          (options?.name === "lungMetastasesResponse_WilmsTumor") ||
          (options?.name === "extraPulmonaryMetastases_WilmsTumor") ||
          (options?.name === "clinicalStaging_WilmsTumor")
        )) {
          //Code for risk stratification 
          let resData = getRiskDataWilmsTumor(options?.value, options?.name, survey)
          let data = survey?.data
          let temp = { ...data, ...resData }
          updateFlag && updateFlag(temp, survey)
          setDataObj(temp)
        }
        else if (options && (
          (options?.name === "AlbuminValues") ||
          (options?.name === "HemoglobinValue") ||
          (options?.name === "HGTValue") ||
          (options?.name === "WBCValue") ||
          (options?.name === "NeutrophilsValue") ||
          (options?.name === "LympocytesValue") ||
          (options?.name === "TotalProteinValue") ||
          (options?.name === "SGPTValue") ||
          (options?.name === "SGOTValue") ||
          (options?.name === "SodiumValue") ||
          (options?.name === "PotassiumValue") ||
          (options?.name === "SCreatinineValue") ||
          (options?.name === "totalBilirubinValue")
        )) {
          handleValidateVitals(survey, options)
        }
      }}
    />
  )
}

export default SurveyComponent

